"use client";
const { useSearchParams, useRouter } = require("next/navigation");

const useClientRouter = (baseUrl) => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const params = new URLSearchParams(searchParams);

  const setPropertyToUrl = (property, value) => {
    params.set(property, value);
    router.push(`/${baseUrl}?${params.toString()}`, { scroll: false });
  };

  const setPropertyToUrlWithArray = (property, value) => {
    if (params.getAll(property).includes(value.toString())) {
      params.delete(property, value);
    } else {
      params.append(property, value);
    }
    router.push(`/${baseUrl}?${params.toString()}`, { scroll: false });
  };

  const deleteParams = (property) => {
    params.delete(property);
  };

  return { params, setPropertyToUrl, setPropertyToUrlWithArray, deleteParams };
};

export default useClientRouter;
